import { FC } from 'react';
import ModuleEntity from '../../../../../../../../domain/entities/ModuleEntity';
import ModulePermision from '../../../../../../../../domain/entities/ModulePermision';

interface PermissionPreviewProps {
    modules: ModuleEntity[];
}

const CHECK_ICON_STYLE: React.CSSProperties = { color: '#28a745', fontWeight: 'bold' };
const CROSS_ICON_STYLE: React.CSSProperties = { color: '#999', fontWeight: 'bold' };

const renderFlag = (value: boolean): JSX.Element =>
    value
        ? <span style={CHECK_ICON_STYLE} aria-label="Enabled">✓</span>
        : <span style={CROSS_ICON_STYLE} aria-label="Disabled">✗</span>;

export const PermissionPreview: FC<PermissionPreviewProps> = ({ modules }) => {
    if (!modules || modules.length === 0) {
        return <p className="permission-preview__empty">No permissions assigned</p>;
    }

    return (
        <div className="permission-preview">
            <table className="permission-preview__table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left', padding: '8px' }}>Permission</th>
                        <th style={{ textAlign: 'center', padding: '8px' }}>View</th>
                        <th style={{ textAlign: 'center', padding: '8px' }}>Create</th>
                        <th style={{ textAlign: 'center', padding: '8px' }}>Edit</th>
                        <th style={{ textAlign: 'center', padding: '8px' }}>Delete</th>
                        <th style={{ textAlign: 'center', padding: '8px' }}>Assign</th>
                    </tr>
                </thead>
                <tbody>
                    {modules.map((module: ModuleEntity) => (
                        <ModuleGroup key={module.id} module={module} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

interface ModuleGroupProps {
    module: ModuleEntity;
}

const ModuleGroup: FC<ModuleGroupProps> = ({ module }) => (
    <>
        <tr className="permission-preview__module-header">
            <td
                colSpan={6}
                style={{ fontWeight: 'bold', padding: '8px 8px 4px', borderTop: '1px solid #eee' }}
            >
                {module.name}
            </td>
        </tr>
        {module.permissions.map((perm: ModulePermision) => (
            <tr key={perm.id} className="permission-preview__row">
                <td style={{ padding: '4px 8px 4px 16px' }}>{perm.name}</td>
                <td style={{ textAlign: 'center', padding: '4px 8px' }}>{renderFlag(perm.canView)}</td>
                <td style={{ textAlign: 'center', padding: '4px 8px' }}>{renderFlag(perm.canCreate)}</td>
                <td style={{ textAlign: 'center', padding: '4px 8px' }}>{renderFlag(perm.canEdit)}</td>
                <td style={{ textAlign: 'center', padding: '4px 8px' }}>{renderFlag(perm.canDelete)}</td>
                <td style={{ textAlign: 'center', padding: '4px 8px' }}>{renderFlag(perm.canAssign)}</td>
            </tr>
        ))}
    </>
);

export default PermissionPreview;
